import React, { Component } from 'react';
import moment from 'moment';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import { formatPrice } from 'common/formatters';

import { LISTING_DATA_SOURCE_SUNROOM } from 'common/listingConstants';

import {
  DATA_TABLE_SOURCE_ADMIN_LISTINGS_LIST,
  DATA_TABLE_VIEW_ID_ADMIN_LISTINGS_LIST_SUNROOM,
} from 'common/dataTableConstants';

import { getListingFullAddressString } from 'common/listingHelpers';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import SrDataTableUI from 'client/components/SrDataTableUI';
import SrDataTableConnected from 'client/components/SrDataTableConnected';

function getDataTableSettingsFromProps(props) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_ADMIN_LISTINGS_LIST,
    rootViewId: DATA_TABLE_VIEW_ID_ADMIN_LISTINGS_LIST_SUNROOM,
    initialViewSettings: {
      filter: {
        dataSource: [LISTING_DATA_SOURCE_SUNROOM],
      },
      customParams: {
        adminListingList: {},
      },
      sort: {
        'listings.updatedDate': 'desc',
      },
      loadAllData: false,
    },
    itemsPropName: 'listings',
    count: 25,
    sortUserSettingsFieldId: 'adminListings.sorting',
  };

  if (props.sorting) {
    dataTableSettings.initialViewSettings.sort = props.sorting;
  }

  if (props.listingStatus) {
    dataTableSettings.initialViewSettings.filter['listings.status'] = props.listingStatus;
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_listingStatus:${props.listingStatus}`;
  }

  if (props.listingManagementCompany) {
    dataTableSettings.initialViewSettings.filter['listings.listingManagementCompany'] =
      props.listingManagementCompany; // eslint-disable-line max-len
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_listingManagementCompany:${props.listingManagementCompany}`; // eslint-disable-line max-len
  }

  if (props.partnerAccountManagerId && props.partnerAccountManagerId.length > 0) {
    dataTableSettings.initialViewSettings.filter['partners.accountManagerUserId'] =
      props.partnerAccountManagerId; // eslint-disable-line max-len
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_accountManager:${props.partnerAccountManagerId}`; // eslint-disable-line max-len
  }

  if (
    Array.isArray(props.partnerLeasingOperationsManagerId) &&
    props.partnerLeasingOperationsManagerId.length > 0
  ) {
    dataTableSettings.initialViewSettings.filter['partners.leasingOperationsManagerUserId'] =
      props.partnerLeasingOperationsManagerId; // eslint-disable-line max-len
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_leasingManager:${props.partnerLeasingOperationsManagerId}`; // eslint-disable-line max-len
  }

  if (props.listingServices && props.listingServices.length > 0) {
    dataTableSettings.initialViewSettings.customParams.adminListingList.listingServices =
      props.listingServices; // eslint-disable-line max-len
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_listingServices:${props.listingServices}`; // eslint-disable-line max-len
  }

  if (props.listingAvailableDates) {
    const listingAvailableDates = props.listingAvailableDates.map((monthValue) => {
      const [year, month] = monthValue.split('_');
      const date = momentWithAustinTimezone()
        .date(1)
        .month(parseInt(month, 10))
        .year(parseInt(year, 10));

      return [date.startOf('month').toISOString(), date.endOf('month').toISOString()];
    });

    dataTableSettings.initialViewSettings.customParams.adminListingList.listingAvailableDates = listingAvailableDates; // eslint-disable-line max-len
    dataTableSettings.rootViewId = `${dataTableSettings.rootViewId}_listingAvailableDates:${props.listingAvailableDates}`; // eslint-disable-line max-len
  }

  return dataTableSettings;
}
class SrDataTableListings extends Component {
  render() {
    return (
      <div className="SrTableContainer">
        <SrDataTableConnected {...getDataTableSettingsFromProps(this.props)}>
          {({ listings, viewSettings, dataTableApiState, onInfiniteScrollWrapperRef }) => (
            <div>
              {dataTableApiState.error && <pre>Error: {dataTableApiState.error}</pre>}
              <SrDataTableUI
                dataTableViewSettings={viewSettings}
                sticky
                headers={[
                  { content: 'id' },
                  { content: 'mls' },
                  { content: 'partner name', dataTableFieldId: 'partnerDisplayName' },
                  { content: 'address' },
                  { content: 'status' },
                  { content: 'price', dataTableFieldId: 'price' },
                  {
                    content: 'available for setup date',
                    dataTableFieldId: 'availableForSetupDate',
                  },
                  { content: 'days on market', dataTableFieldId: 'daysOnMarket' },
                  { content: 'available date', dataTableFieldId: 'availableDate' },
                  { content: 'occupant type', dataTableFieldId: 'occupantType' },
                  { content: 'sunlock serial' },
                  { content: 'account manager', dataTableFieldId: 'accountManagerName' },
                  {
                    content: 'leasing operations manager',
                    dataTableFieldId: 'leasingOperationsManager',
                  },
                  { content: 'links' },
                ]}
                rows={listings.map((listing) => ({
                  cells: [
                    {
                      content: (
                        <SrLink target="_blank" to={`/listing/${listing.id}`}>
                          {listing.id}
                        </SrLink>
                      ),
                    },
                    { content: listing.mlsNumber || '--' },
                    {
                      content: !listing.partnerDisplayName ? (
                        '--'
                      ) : (
                        <SrLink
                          target="_blank"
                          to={`/partner/${listing.partnerSlug}/listing/${listing.id}`}
                        >
                          {listing.partnerDisplayName}
                        </SrLink>
                      ),
                    },
                    { content: getListingFullAddressString(listing) },
                    { content: listing.status },
                    { content: listing.price ? formatPrice(listing.price) : '--' },
                    {
                      content: listing.availableForSetupDate
                        ? moment(listing.availableForSetupDate).format('MMM Do, YYYY')
                        : '--',
                    },
                    {
                      content:
                        typeof listing.daysOnMarket === 'number' ? listing.daysOnMarket : '--',
                    },
                    {
                      content: listing.availableDate
                        ? moment(listing.availableDate).format('MMM Do, YYYY')
                        : '--',
                    },
                    { content: listing.occupantType || '--' },
                    { content: (listing.raspberryPiSerialNumber || '').slice(-4) || '--' },
                    { content: listing.accountManagerName || '--' },
                    {
                      content: listing.leasingOperationsManager ? (
                        <SrBox key={listing.leasingOperationsManager?.phone}>
                          <SrText display="block">{listing.leasingOperationsManager?.name}</SrText>
                        </SrBox>
                      ) : (
                        '--'
                      ),
                    },
                    {
                      content: (
                        <SrLink target="_blank" to={`/admin/listings/edit/${listing.id}`}>
                          Edit
                        </SrLink>
                      ),
                    },
                  ],
                }))}
              />
              <div ref={onInfiniteScrollWrapperRef} />
              {dataTableApiState.inProgress && <div className="loading-ellipses" />}
            </div>
          )}
        </SrDataTableConnected>
      </div>
    );
  }
}

SrDataTableListings.displayName = 'SrDataTableListings';

export default SrDataTableListings;
